import axios from 'axios'
import urlConfig from './config'
import qs from 'qs'
import { captureException } from './utils/util'

const service = axios.create({
  baseURL: urlConfig.listURL,
  timeout: 8000
  // headers: {
  //   'Content-Type': 'application/x-www-form-urlencoded'
  // },
})

service.interceptors.response.use(function (config) {
  return config
}, function (error) {
  captureException(error)
  return Promise.reject(error)
})

const wwwService = axios.create({
  baseURL: '/official/api',
  timeout: 8000,
  transformRequest: [function (data) {
    data = qs.stringify(data)
    return data
  }],
  headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' }
})

wwwService.interceptors.response.use(function (config) {
  return config
}, function (error) {
  captureException(error)
  return Promise.reject(error)
})

const ajax = axios.create({
  timeout: 8000,
  transformRequest: [function (data) {
    data = qs.stringify(data)
    return data
  }],
  headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' }
})

const testSerice = axios.create({
  timeout: 8000,
  transformRequest: [function (data) {
    data = qs.stringify(data)
    return data
  }],
  headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' }
})

testSerice.interceptors.response.use(function (config) {
  return config
}, function (error) {
  captureException(error)
  return Promise.reject(error)
})

wwwService.interceptors.request.use(function (config) {
  return config
}, function (error) {
  return Promise.reject(error)
})

wwwService.interceptors.response.use(function (config) {
  return config
}, function (error) {
  captureException(error)
  return Promise.reject(error)
})

const parentService = axios.create({
  // baseURL: urlConfig.parentURL,
  timeout: 5000,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
    'Api-Version': '1.3.0'
  },
  transformRequest: [function (data) {
    data = qs.stringify(data)
    return data
  }]
})

parentService.interceptors.response.use(function (config) {
  return config
}, function (error) {
  captureException(error)
  return Promise.reject(error)
})

// eslint-disable-next-line
const parentService2_1_0 = axios.create({
  // baseURL: urlConfig.parentURL,
  timeout: 5000,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
    'Api-Version': '2.1.0'
  },
  transformRequest: [function (data) {
    data = qs.stringify(data)
    return data
  }]
})

parentService2_1_0.interceptors.response.use(function (config) {
  return config
}, function (error) {
  captureException(error)
  return Promise.reject(error)
})

const communityService = axios.create({
  timeout: 5000,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'community-sdk': '2.0.0'
  }
})

communityService.interceptors.response.use(function (config) {
  return config
}, function (error) {
  captureException(error)
  return Promise.reject(error)
})

const communityServer = axios.create({
  timeout: 5000,
  headers: {
    'Content-Type': 'application/json',
    'community-sdk': '2.0.0'
  }
})

communityServer.interceptors.response.use(function (config) {
  return config
}, function (error) {
  captureException(error)
  return Promise.reject(error)
})

const weiService = axios.create({
  timeout: 5000,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
    'Api-Version': '1.3.0'
  },
  transformRequest: [function (data) {
    data = qs.stringify(data)
    return data
  }]
})

weiService.interceptors.response.use(function (config) {
  return config
}, function (error) {
  captureException(error)
  return Promise.reject(error)
})

const marketService = axios.create({
  baseURL: urlConfig.marketURL,
  timeout: 5000,
  // headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' }
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
    Accept: 'application/json'
    //   'X-Requested-With': 'XMLHttpRequest'
  }
})

marketService.interceptors.response.use(function (config) {
  return config
}, function (error) {
  captureException(error)
  return Promise.reject(error)
})

const wxAdTestService = axios.create({
  timeout: 5000,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  }
})

wxAdTestService.interceptors.response.use(function (config) {
  return config
}, function (error) {
  captureException(error)
  return Promise.reject(error)
})

export default {
  encryptionMobile (data) {
    return axios({
      method: 'post',
      url: '/opGateway/api/safetycover-service/id/encrypt/batch',
      data: data,
      headers: {
        appId: process.env.NODE_ENV === 'production' ? 'JfIJZrJKSuaYo7EQMkf9yg' : 'c61iamqhaT1m0gKBueCaavQ',
        'Content-Type': 'application/json;charset=utf-8'
      }
    })
  },
  postTestAxios (url, params) {
    return testSerice.post(
      url,
      params
    )
  },
  postTestAxios1 (url, params) {
    return testSerice.post(
      '/api/learningCenter/get-bind-qrcode',
      params
    )
  },
  postTestAxios1Encryption (data) {
    return axios({
        method: 'post',
        url: '/opGateway/api/operation-wechat-service/v1/weixin/common/getBindQrcode/v1',
        headers: {
          'Content-Type': 'application/json;charset=UTF-8'
        },
        data: data
    })
  },
  getAllProvinces (params) {
    return axios({
      method: 'get',
      url: '/opGateway/api/market-web-server/v1/dict/provinceCityCounty',
      params: params
    })
  },
  getRes (params) {
    return marketService.post(
      '/api/cooperation/getRes',
      params
      )
  },

  // getNewsList (params) {
  //   return service({
  //     method: 'post',
  //     url: '/info/infos',
  //     params: params
  //   })
  // },
  // getNewsDetail (params) {
  //   return service({
  //     method: 'post',
  //     url: '/info/info',
  //     params: params
  //   })
  // },
  // 走的课程预约接口
  postLessonForm (apiUrl = '/opGateway/api/market-web-server/v1/registration/appointment', params) {
    if (apiUrl === '/student/register-and-book') {
      return wwwService.post(
        apiUrl,
        params
      )
    }

    // 为了兼容老数据这里做统一处理
    if (params) {
      const map = {
        grade: 'stuGrade',
        channel_code: 'code',
        channel_keyword: 'key'
      }

      for (const key in params) {
        if (key in map) {
          params[map[key]] = params[key]
          delete params[key]
        }
      }
    }

    return axios.post(
      apiUrl,
      params
    )
  },
  postLessonForm1 (apiUrl, params) {
    return wwwService.post(
      apiUrl,
      params
    )
  },
  // 599元预约
  saveCooperatorStuSpecial (params) {
    return wwwService.post(
      '/student/save-cooperator-stu-special',
      params
    )
  },
  // 预约排练
  postLessonFormPeilian (params) {
    return wwwService.post(
      '/student/register-peilian',
      params
    )
  },
  // 是否预约过陪练
  postLessonHasPeilian (params) {
    return wwwService({
      method: 'get',
      url: '/student/has-register-peilian',
      params: params
    })
  },
  postYuanjing (apiUrl, params) {
    return wwwService.post(
      apiUrl,
      params
    )
  },
  getPlatformOnOffStatus (params) {
      return axios({
        method: 'get',
        url: '/opGateway/api/operation-web-server/v1/user/sem-channel-switch',
        params
      })
  },
  // 新的验证码接口 java提供
  sendVerifierNewActive (params) {
    return axios.post(
      `/opGateway/api/market-web-server/v1/registration/sendSms`,
      params
    )
  },
  // 极验
  geetestApi1(data) {
    return axios({
      method: 'get',
      url: "/opGateway/api/market-web-server/v1/out/geetest/register/api1",
      headers: {
        'Content-Type': 'application/json;charset=utf-8'
      },
      params: data
    })
  },
  // 撞库
  geetestReg(data) {
    return axios({
      method: 'post',
      url: "/op-gateway/api/market-web-server/v1/out/geetest/reg",
      headers: {
        'Content-Type': 'application/json;charset=utf-8'
      },
      data: data
    })
  },
  // 撞库
  appointmentReg(data) {
    return axios({
      method: 'post',
      url: "/op-gateway/api/market-web-server/v1/out/geetest/appointment/reg",
      headers: {
        'Content-Type': 'application/json;charset=utf-8'
      },
      data: data
    })
  },
  registrationRegV3(data) {
    return axios({
      method: 'post',
      url: "/op-gateway/api/market-web-server/v3/registration/reg",
      headers: {
        'Content-Type': 'application/json;charset=utf-8'
      },
      data: data
    })
  },
  // 新的验证码接口 java提供
  sendVerifierNew (params) {
    return axios.post(
      '/opGateway/api/market-web-server/v1/registration/sendSms',
      params
    )
  },
  SendVerificationCode (params) {
    return axios.post(
      '/opGateway/api/market-web-server/v1/out/geetest/sendSms',
      params
    )
  },
  
  sendVerifierOld (params) {
    return wwwService.post(
      '/user/send-sms-verifier',
      params
    )
  },
  // 新的验证码校验接口
  validateNewActive (params) {
    return axios.post(
      `/opGateway/api/market-web-server/v1/registration/checkCode`,
      params
    )
  },
  // 新的验证码校验接口
  validateNew (params) {
    return axios.post(
      '/opGateway/api/market-web-server/v1/registration/checkCode',
      params
    )
  },
  // userId解密接口
  regUserId (params) {
    return axios({
        method: 'get',
        url: `/opGateway/api/market-web-server/v1/reg/regUserId?userIdStr=${params}`
    })
  },
  // 获取定位
  getOperation () {
    return axios({
        method: 'get',
        url:'/opGateway/api/market-web-server/v2/registration/getOperation'
    })
  },
  validateOld (params) {
    return wwwService.post(
      '/student/validate-and-tag',
      params
    )
  },
  tagAppointmen (data) {
    return axios({
      method: 'post',
      url: '/official/api/student/tag-appointment',
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      },
      data: data
    })
  },
  checkIsNewUser (params) {
    return axios({
      method: 'get',
      url: '/official/api/user/user-state',
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      },
      params
    })
  },
  getQrcode () {
    return wwwService.post(
      '/qrcode/find-visible-mobile-api'
    )
  },
  getPvNum (params) {
    return wwwService.post(
      '/user/get-statistic-pv',
      params
    )
  },
  makeCall (params) {
    return wwwService.post(
      '/call-center/make-direct-call',
      params
    )
  },
  registerStep1 (data) {
    return wwwService({
      method: 'post',
      url: '/student/register-and-book-by-step',
      data
    })
  },
  registerStep2 (data) {
    return wwwService({
      method: 'post',
      url: '/student/register-and-book-by-step',
      data
    })
  },
  getUrlDownload (data) {
    return wwwService({
      method: 'post',
      url: '/user/get-app-url',
      data
    })
  },
  getTeacherInfo (data) {
    return axios({
      timeout: 8000,
      method: 'post',
      url: '/clientPlatform/teacher/get-teacher-description',
      data
    })
  },
  getBannerData () {
    const apiurl = `/zixun/get-banner?condition={"group_id":"${urlConfig.bannerGroupID}"}`
    return wwwService.get(apiurl)
  },
  // 家长端
  getPersonInfo (apiUrl) {
    return parentService.post(
      apiUrl
    )
  },
  getParentTeacherInfo (data) {
    return parentService({
      method: 'post',
      url: '/parentsApp/teacher/introduction',
      data
    })
  },
  // 加密接口
  shareEncrypt (params) {
    return parentService({
      method: 'post',
      url: '/parentsApp/share/encrypt',
      params
    })
  },
  // 家长端 测评课报告
  querySharedEstimateLessonReport (data) {
    return parentService({
      method: 'post',
      url: '/parentsApp/share/open/querySharedEstimateLessonReport',
      data
    })
  },
  querySharedEstimateLessonReport2 (data) {
    return parentService2_1_0({
      method: 'post',
      url: '/parentsApp/share/open/querySharedEstimateLessonReportNew',
      params: data
    })
  },
  getWxLinkUrl (params = {}) {
    return wwwService({
      method: 'get',
      url: '/tools/get-wx-url',
      params
    })
  },
  querySharedOfficialLessonReport (data) {
    return parentService({
      method: 'post',
      url: '/parentsApp/share/open/querySharedOfficialLessonReport',
      data
    })
  },
  querySharedOfficialLessonReport2 (data) {
    return parentService2_1_0({
      method: 'post',
      url: '/parentsApp/share/open/querySharedOfficialLessonReport',
      data
    })
  },
  // 教师介绍 加密接口
  shareOpenEncrypt (params) {
    return parentService({
      method: 'post',
      url: '/parentsApp/share/open/encrypt',
      params
    })
  },
  getSecondShareKey (data) {
    return weiService({
      method: 'post',
      url: '/wechat/kid/get-signature',
      data
    })
  },
  //   这个接口获取的前面的`掌门陪练在线1对1`订阅号的分享签名
  getSecondShareKey1 (data, appId) {
    return axios({
      method: 'post',
      url: '/wechat/java/services/wxApiJsService/get_js_signature',
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      },
      data: {
        url: data.signUrl,
        appId: appId
      }
    })
  },
  getImage (data) {
    return axios({
      method: 'get',
      url: '/opGateway/api/operation-activity-center/v1/uv/getImage',
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      },
      data: data
    })
  },
  sendEvaluate (data) {
    // @desc 2018.4.4日新增用于统计评估用户
    // @author Hu Shiyu
    // xiugai
    return axios({
      method: 'post',
      url: urlConfig.evaluateURL + '/student/get-evaluate-url',
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      },
      data: data
    })
  },
  getColumnInfo (data) {
    return communityService({
      method: 'post',
      url: '/community/section/detail',
      data
    })
  },

  // 家长端 个人中心
  getUserInfo (data) {
    return communityServer({
      method: 'post',
      url: '/community/user/homepage',
      params: data
    })
  },
  // 家长端 答案详情
  getAnswerDetail (data) {
    return communityServer({
      method: 'post',
      url: '/community/answer/detail',
      data
    })
  },
  // 家长端 问题详情
  getQuestionDetail (data) {
    return communityServer({
      method: 'post',
      url: '/community/question/detail',
      data
    })
  },
  // 添加课程评价
  insertSelective (option = {}) {
    return wwwService({
      method: 'post',
      url: '/zxfd/insert-valuate',
      data: option
    })
  },
  // 获得学生家长ID
  getParentId (option = '') {
    return wwwService({
      method: 'get',
      url: '/zxfd/get-parent-id',
      params: {
        studentId: option
      }
    })
  },
  getSubjectData () {
    return axios({
      method: 'post',
      url: `/opGateway/api/operation-web-server/v1/ows/getDictGrade`,
      headers: {
        'Content-Type': 'application/json;charset=utf-8'
      },
      data: {}
    })
  },
  ocpcTrack (data) {
    return axios({
      method: 'post',
      url: `/opGateway/api/operation-web-server/v1/ows/ocpcBaidu`,
      headers: {
        'Content-Type': 'application/json;charset=utf-8'
      },
      data
    })
  },
  // 亿玛数据回传统计
  yimaTrack (params = {}) {
    return axios({
      method: 'get',
      url: 'https://open.adhudong.com/saveEffect.htm',
      headers: {
        'Content-Type': 'application/json;charset=utf-8'
      },
      params
    })
  },
  // sem 获取数据
  getSemSignCount (data) {
    return axios({
      method: 'post',
      url: `/opGateway/api/operation-web-server/v1/ows/getData`,
      headers: {
        'Content-Type': 'application/json;charset=utf-8'
      },
      data
    })
  },
  // 获取短链接
  createUrl (data) {
    return axios({
      method: 'post',
      url: '/urlcreate/api/v2/url',
      data
    })
  },
  // 微信朋友圈广告api
  wxAdTest (method, url, data) {
    return wxAdTestService({
      method,
      url,
      data
    })
  },
  wpsApi (params) {
    return axios({
      method: 'post',
      url: `${urlConfig.nodeHost}/api/advertiser/advertiser`,
      data: params
    })
  },

  adCallbackWechat (params) {
    return ajax({
      method: 'post',
      url: '/opGateway/api/market-content-server/v1/wechat/adCallbackWechat',
      data: params
    })
  },

  wechatAdvert (params) {
    return axios({
      method: 'post',
      url: '/opGateway/api/market-content-server/v1/wechat/wechatAdvert/callback',
      headers: {
        'Content-Type': 'application/json;charset=utf-8'
      },
      data: params
    })
  },

  jingdongAPi (url, params = {}) {
    return axios({
      method: 'get',
      url: url,
      params: params
    })
  },

  updateNamePc (params) {
    return axios.post(
      '/official/api/student/update-name',
      params
    )
  },

  getChannelKeyWord (params) {
    return ajax({
      method: 'get',
      url: '/opGateway/api/market-content-server/v1/advert/channelKeyWord/get',
      params
    })
  },

  saveComments (data) {
    return axios({
      method: 'post',
      url: '/opGateway/api/market-web-server/v1/registration/saveComments',
      data: data
    })
  },
  guoqingActicity19 () {
    return axios({
      method: 'post',
      url: '/official/api/activity/bless'
    })
  },
  checkRedeemCode (data) {
    return axios({
      method: 'post',
      url: '/opGateway/api/operation-activity-center/v1/redeem/checkRedeemCode',
      data: data
    })
  },

  errorPageHandler (data) {
    return axios({
      method: 'post',
      url: '/user/api/benz/monitor/errorPageHandler',
      data: data
    })
  },

  checkUsersExist (data) {
    return axios({
      method: 'post',
      url: '/opGateway/api/operation-activity-center/v1/redeem/checkUsersExist',
      data: data
    })
  },

  checkUsersRedeemCode (params) {
    return axios({
      method: 'get',
      url: '/opGateway/api/operation-activity-center/v1/redeem/checkUsersRedeemCode',
      params
    })
  },

  channelAssignTeam (data) {
    return axios({
      method: 'post',
      url: '/opGateway/api/operation-activity-center/v1/redeem/channelAssignTeam',
      data: data
    })
  },

  requestSuccessABTestApi (data) {
    return axios({
      method: 'post',
      url: '/chatGateway/tk-abt/api/white/experiment/selectBucket',
      data: data
    }).then(res => {
      return res.data
    })
  },

  getWechatKidQrcode (params) {
    return axios.post(
      '/opGateway/kids/api/wechat/Wx/qrcode/getWechatQrcodeEncrypt',
      params
    )
  },

  /**
   * 获取手机号码区号列表
   */
  getAreaCodeList () {
    return axios({
      url: `/opGateway/api/market-web-server/v1/dict/getCountryCode`,
      method: 'GET'
    }).then(res => res.data)
  },

  /**
   * 海外用户注册
   * @param {*} data
   */
  appoint2 (data) {
    return axios({
      url: `/opGateway/api/market-web-server/v3/registration/appointment`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      },
      data
    }).then(res => res.data)
  },
  kidComment(data) {
    return axios({
      method: 'post',
      url: `/opGateway/api/operation-activity-center/v1/act/support/kidComment`,
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      },
      data
    })
  },
  getNewBannerData(params) {
    return axios.get (
      '/opGateway/api/operation-web-server/v1/ow/getBannerDoing',
      {
        params,
        timeout: 5000,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        }
      }
    )
  },
  insertSamSungActivityInfo (data) {
    return axios({
      method: 'post',
      url: '/opGateway/api/operation-activity-center/v1/redeem/insertSamSungActivityInfo',
      data: data
    })
  },
  insertSamSungActivityOtherInfo (data) {
    return axios({
      method: 'post',
      url: '/opGateway/api/operation-activity-center/v1/redeem/insertSamSungActivityOtherInfo',
      data: data
    })
  },

  checkJDRedeemCode(data) {
    return axios({
      method: 'post',
      url: '/opGateway/api/operation-activity-center/v1/redeem/checkJDRedeemCode',
      data
    })
  },
  sendAwardJD(data) {
    return axios({
      method: 'post',
      url: '/opGateway/api/operation-activity-center/v1/redeem/sendAwardJD',
      data
    })
  },
  getUrlScheme (data) {
    return axios({
      method: 'post',
      url: '/opGateway/api/operation-honey-badger/v1/wechat/customer/applet/url_scheme?appletAppId=wxbbf501186b99c807',
      data: data
    })
  }
}
